import { swalErro, swalSave } from '../../utils/swal';
import httpClient, { isHttpError } from '../httpClient';

export async function getAllFornecedorRepresentantes() {
  try {
    const response = await httpClient.get(`/api/fornecedorrepresentante`);
    console.log(response.data);
    return Array.isArray(response.data.registros)
      ? response.data.registros
      : [];
  } catch (error) {
    throw new Error('Erro ao obter lista de Registros: ' + error);
  }
}

export async function getRepresentantesByFornecedor(fornecedorId: string) {
  try {
    const response = await httpClient.get(
      `/api/fornecedorrepresentante/fornecedor/${fornecedorId}`,
    );
    return response.data;
  } catch (error) {
    throw new Error('Erro ao obter lista de Registros: ' + error);
  }
}

export async function createRepresentante(form: any) {
  try {
    // const token = 'JWT_SECRET';
    console.log(form);
    const response = await httpClient.post(
      `/api/fornecedorrepresentante`,
      form,
    );

    swalSave();
    setTimeout(
      () =>
        (window.location.href = `/daf/fornecedores/fornecedores/ficha/${response.data.fornecedor.id}/representantes`),
      2500,
    );

    return response.data;
  } catch (error: any) {
    if (isHttpError(error)) {
      swalErro(error.response?.data.message);
    }
    console.error('Erro ao salvar registro:', error);
    console.log('Erro: ', error.message);
  }
}
